import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'

import harbal from "../images/Harbal.jpg";
import HERBALCAPSUL from "../images/HERBAL CAPSUL.jpg";
import HERBALJUICE from "../images/Alpino Aloe Vera Body Detox juice.png";
import HERBALDROP from "../images/HERBAL DROP.jpg";


import HERBALTABLET from "../images/HERBAL TABLET.jpg";
import HERBALPOWDER from "../images/HERBAL POWDER.jpg";
import HERBALOIL from "../images/HERBAL OIL.jpg";
import HERBALSYRUP from "../images/HERBAL SYRUP.jpg";

import COSMETICPRODUCT from "../images/COSMETIC PRODUCT.jpg";


import ScrollToTop from "react-scroll-to-top";


import "./Home.css";

function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <Slider />
      <ScrollToTop smooth top="100" color="Darkblue" />
      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='Herbal'>

                    <img src={harbal} className="card-img-top" alt="hErbal" />
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL</h5>
                    <a href="Herbal" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>

                </div>              </div>

            </div>
            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalCapsul'>
                    <img src={HERBALCAPSUL} className="card-img-top" alt="HERBALCAPSUL" />
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL CAPSUL </h5>
                    <a href="HerbalCapsul" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>

            </div>

            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalJucie'>
                    <img src={HERBALJUICE} className="card-img-top" alt="HERBALJUICE"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL JUICE</h5>
                    <a href="HerbalJucie" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>

            </div>
            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalDrop'>
                    <img src={HERBALDROP} className="card-img-top" alt="HERBAL DROP"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL DROP</h5>
                    <a href="HerbalDrop" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalTablet'>
                    <img src={HERBALTABLET} className="card-img-top" alt="HERBALTABLET"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL TABLET</h5>
                    <a href="HerbalTablet" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>

            </div>
            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalPowder'>
                    <img src={HERBALPOWDER} className="card-img-top" alt="HERBALPOWDER"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL POWDER</h5>
                    <a href="HerbalPowder" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalOil'>
                    <img src={HERBALOIL} className="card-img-top" alt="HERBALOIL"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL OIL</h5>
                    <a href="HerbalOil" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='HerbalSyrup'>
                    <img src={HERBALSYRUP} className="card-img-top" alt="HERBALSYRUP"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">HERBAL SYRUP</h5>
                    <a href="HerbalSyrup" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>
            </div>

             <div className="col-md-3 mt-3">
              <div className='hovarnew'>
                <div className="card" >
                  <a href='Cosmetics'>
                    <img src={COSMETICPRODUCT} className="card-img-top" alt="COSMETICPRODUCT"/>
                  </a>
                  <div className="card-body">
                    <h5 className="card-title">COSMETIC PRODUCT</h5>
                    <a href="Cosmetics" className="cartbutton">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <br />
    </div >
  )
}

export default Home